export const getBaseHostUrl = (): string => {
  const hostApi = process.env.REACT_APP_API_URL;

  if (!hostApi) {
    console.error('No host API given');
    return '';
  }

  return hostApi;
};
